module.exports = __webpack_public_path__ + "img/pageIndex_bg.803141dd.png";